// non character regex
export const format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
